import React from "react"
import styled from "styled-components"

import shareImg from "@irati-web/recognition/src/images/share.svg"
import theme from "@irati/ui/src/global/theme"

const FlexRow = styled.div`
  display: flex;
  align-items: center;
`

const StyledImg = styled.img`
  ${({size}) => `
    width: ${size}px;
    height: ${size}px;
  `}
  margin-right: 10px;
  background-color: ${theme.colors.greys.white};
`

const ShareRow = (share) => {
  return (
    <FlexRow>
      <StyledImg src={shareImg} size={15} />
      <div>{share.label}</div>
    </FlexRow>
  )
}

export default ShareRow
